import { RenderableProduct } from "../../types/types";

export const getProductKey = (product: RenderableProduct): string => {
  const variantId =
    !product.isSkeleton && product.initialVariantId
      ? "-" + product.initialVariantId
      : "";
  const sponsoredStatus =
    !product.isSkeleton && product.advertising ? "sponsored" : "standard";
  return `${product.aliases.pimProductId}${variantId}-${sponsoredStatus}`;
};
